import { LoadingService } from '../../../../../shared/services/loading/loading.service';

export const overviewTabLoadingService = new LoadingService();
